import { render } from "./ImportSurveyGroup.vue?vue&type=template&id=1f3cca1a"
import script from "./ImportSurveyGroup.vue?vue&type=script&lang=js"
export * from "./ImportSurveyGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__